import {createStore, createEvent, Store, Step} from '@effector/effector'

export type ID = string
export type Edge = {
  id: ID
  label: string
  node: Step
  source: ID
  target: ID
}
export type Node =
  | NodeEvent
  | NodeStore
  | NodeEffect
  | NodeWatch
  | NodeSample
  | NodeOn
  | NodeForward
export type NodeEvent = {
  id: ID
  label: string
  node: Step
  unit: 'event'
  exclude: boolean
}
export type NodeStore = {
  id: ID
  label: string
  node: Step
  unit: 'store'
  exclude: boolean
}
export type NodeEffect = {
  id: ID
  label: string
  node: Step
  unit: 'effect'
  exclude: boolean
}
export type NodeWatch = {
  id: ID
  label: string
  node: Step
  op: 'watch'
  owner: ID
  sources: string
  exclude: boolean
}
export type NodeSample = {
  id: ID
  label: string
  node: Step
  op: 'sample'
  source: ID
  clock: ID
  target: ID
  exclude: boolean
}
export type NodeOn = {
  id: ID
  label: string
  node: Step
  op: 'on'
  source: ID
  clock: ID
  sources: string
  exclude: boolean
}
export type NodeForward = {
  id: ID
  label: string
  node: Step
  op: 'forward'
  source: ID
  target: ID
  exclude: boolean
}

export const workingSet: Store<{
  nodes: Node[]
  edges: Edge[]
}> = createStore({
  nodes: [],
  edges: []
})

export const nodes$ = workingSet
  .map(({nodes}) => nodes)
  .map(list => {
    const ids = list.map(({id}) => id)
    return [...list].sort((a, b) => {
      return ids.indexOf(a.id) - ids.indexOf(b.id)
    })
  })

export const runRuntime = createEvent<any>()
